module.exports = __webpack_public_path__ + "static/media/iconfinder_band-aid_4900413.f7e18271.svg";